module.exports = __webpack_public_path__ + "static/media/card3_3.52123c2f.png";